import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsDownRightChevronCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.657 2.343A8 8 0 1 0 2.343 13.657A8 8 0 0 0 13.657 2.343M3.05 8l3.182 3.182h4.95v-4.95L8 3.05V8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsDownRightChevronCircle
